const DEFAULT_QUEUE_OPTIONS = {
  maxItems: 100,
};

const QUEUE_NAME = 'rudder_destinations_events';

const NATIVE_DESTINATION_QUEUE_PLUGIN = 'NativeDestinationQueuePlugin';

export { DEFAULT_QUEUE_OPTIONS, QUEUE_NAME, NATIVE_DESTINATION_QUEUE_PLUGIN };
